import { render } from "./ApplicationMGKaunetComponent.vue?vue&type=template&id=55b26c2a&scoped=true&ts=true"
import script from "./ApplicationMGKaunetComponent.vue?vue&type=script&lang=ts"
export * from "./ApplicationMGKaunetComponent.vue?vue&type=script&lang=ts"

import "./ApplicationMGKaunetComponent.vue?vue&type=style&index=0&id=55b26c2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b26c2a"]])

export default __exports__